import React, { useEffect } from 'react'
import * as THREE from 'three'
import { useVideoTexture } from '@react-three/drei'

interface VideoHorizonProps {
    url: string // Path to your local video (e.g., '/assets/video/matrix.mp4')
}

export function VideoHorizon({ url }: VideoHorizonProps) {
    // 1. Load the Video
    // "useVideoTexture" handles the HTML5 video element logic for us
    const texture = useVideoTexture(url, {
        unsuspend: 'canplay', // Wait for it to buffer
        muted: false,         // Audio ON (You want to hear the rain/city)
        loop: true,
        start: true,
        crossOrigin: 'Anonymous'
    })

    // 2. Fix Colors (Videos can look washed out in 3D without this)
    useEffect(() => {
        if (texture) {
            texture.colorSpace = THREE.SRGBColorSpace // Updated for newer Three.js (was encoding)
        }
    }, [texture])

    return (
        // 3. The Sphere
        // scale={[-1, 1, 1]} flips the texture to the INSIDE of the sphere
        <mesh scale={[-500, 500, 500]} rotation={[0, -Math.PI / 2, 0]}>
            <sphereGeometry args={[1, 64, 64]} />
            {/* BasicMaterial is cheapest for performance - no lighting needed */}
            <meshBasicMaterial map={texture} side={THREE.BackSide} toneMapped={false} />
        </mesh>
    )
}
